import { graphql, useStaticQuery } from 'gatsby';

export const useGlobalConfig = () => {
	const data = useStaticQuery(graphql`
		query {
			contentstackGlobalConfig {
				cookies {
					heading
					description
					link_1_text
				}
				stock_window_zip_error
				signed_out {
					image {
						...Image
						image {
							url
							gatsbyImageData(quality: 90)
						}
					}
					subheading
					heading
					description
					ctas {
						...CTA
					}
				}
				identify {
					heading
					subheading
					identifier_type {
						heading
						subheading
					}
				}
				error_handling {
					heading
					description
					cta_title
					cta {
						...CTA
					}
				}
				showroom {
					cta {
						...CTA
					}
					sections {
						section_id
						heading
						subheading
					}
					get_offer {
						...CTA
					}
					disclosure_modal
					coming_soon
					promo_heading
					showroom_type {
						type
						material_symbol
						heading
						tooltip
					}
					special_hours
				}
				reviews {
					heading
					description
					heading_1
					heading_2
				}
				rta {
					heading
					subheading
					description
				}
				rta_cards {
					heading
					card {
						material_symbol
						heading
						ho_text
						pro_text
						cta_heading
						cta {
							...CTA
						}
					}
				}
				branch_location {
					heading
					location_services {
						heading
						entries {
							service_type
							material_symbol
							heading
							tooltip
						}
					}
					faq {
						heading
						answers {
							file {
								url
								gatsbyImageData(quality: 90)
							}
							heading
							description
						}
					}
				}
				postal_code_change {
					confirm
					confirm_no
					confirm_yes
					heading
				}
				session_timeout {
					description
					heading
					timeout_ok
				}
				ratings_buy_cards {
					...CardSection
				}
				ratings_explore {
					...CardSection
				}
				instructions_cards {
					...CardSection
				}
				sem_pella_promise {
					...CardSection
				}
			}
		}
	`);

	return data.contentstackGlobalConfig;
};
